const tabFactory = ($, _, document, window) => (triggers, targets, options) => {
  const CLASSNAME = {
    ACTIVE: 'active',
    DISABLED: 'disabled',
    SHOW: 'show',
  };

  const makeActive = (xs, el, className) => {
    xs.forEach((x) => {
      if ($.hasClass(className, x)) {
        $.removeClass(className, x);
      }
    });
    $.addClass(className, el);
  };

  const switchAttrTrue = (xs, el, attr) => {
    xs.forEach((x) => {
      if ($.getAttribute(attr, x) === 'true') {
        $.setAttribute(attr, 'false', x);
      }
    });
    $.setAttribute(attr, 'true', el);
  };

  const setOpen = (i) => {
    if ($.hasClass(CLASSNAME.DISABLED, triggers[i])) {
      return;
    }
    // triggers (tab-button)
    if (!$.hasClass(CLASSNAME.ACTIVE, triggers[i])) {
      makeActive(triggers, triggers[i], CLASSNAME.ACTIVE);
      switchAttrTrue(triggers, triggers[i], 'aria-selected');
    }
    // targets (tab-panel)
    if (!$.hasClass(CLASSNAME.ACTIVE, targets[i])) {
      makeActive(targets, targets[i], CLASSNAME.ACTIVE);
    }
  };

  const handleClickFactory = _.memoizeWith(_.identity, (i) => (e) => {
    e.preventDefault();
    setOpen(i);
  });

  const bindEvents = (fn) => {
    triggers.forEach((x, i) => {
      // console.log(fn.toString().substring(28, 39), i, handleClickFactory(i) === handleClickFactory(i))
      fn('click', handleClickFactory(i), x);
    });
  };

  const destroy = () => {
    bindEvents($.off);
  };

  const init = () => {
    bindEvents($.on);
  };

  init();

  return {
    destroy: destroy,
  };
};

export default tabFactory;
